"use client";

import { useMutation } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "@/components/pop-ui/pop-toast";
import { authClient } from "@/lib/auth/auth-client";
import { useORPC } from "@/providers/orpc-provider";
const GUEST_USER_EMAIL_KEY = "guestUserEmail";

/**
 * 购物车合并hook
 * 用于处理匿名用户登录后的购物车合并逻辑
 * 自动处理匿名用户ID的保存和购物车合并
 */
export function useCartMerge() {
  const orpc = useORPC();
  const {
    data: session
  } = authClient.useSession();
  const userProfile = session?.user;
  const isAnonymous = userProfile?.isAnonymous;
  const {
    mutateAsync: mergeCart,
    isPending
  } = useMutation({
    ...orpc.ec.cart.merge.mutationOptions(),
    onSuccess: _data => {
      localStorage.removeItem(GUEST_USER_EMAIL_KEY);
    },
    onError: error => {
      console.error("合并购物车失败:", error);
      toast.error("合并购物车失败，请重试");
    }
  });

  // 自动保存匿名用户ID到本地存储
  useEffect(() => {
    if (isAnonymous && userProfile?.id) {
      saveGuestUserId(userProfile.id);
    }
  }, [isAnonymous, userProfile?.id]);

  /**
   * 处理登录成功后的购物车合并
   */
  const handleLoginSuccess = async () => {
    const guestUserId = localStorage.getItem(GUEST_USER_EMAIL_KEY);
    if (!guestUserId || !userProfile) return;
    try {
      await mergeCart({
        guestUserId
      });
    } catch (error_0) {
      console.error("购物车合并过程中出错:", error_0);
    }
  };

  /**
   * 保存访客用户ID到本地存储
   */
  const saveGuestUserId = (userId: string) => {
    localStorage.setItem(GUEST_USER_EMAIL_KEY, userId);
  };
  return {
    handleLoginSuccess,
    saveGuestUserId,
    isMerging: isPending
  };
}